import Api from '~/config/Api'
const endpoint = Api.coupons

export default {
  async detail (couponCode) {
    const detailEndpoint = endpoint + '/' + couponCode
    const { data } = await useApi(detailEndpoint)

    return data
  }
}
